import { SideNavLayout, SideNavLayoutProps } from "@homebound/beam";
import { Outlet } from "react-router-dom";

type BeamSideNavLayoutProps = Omit<SideNavLayoutProps, "children"> & {
  /** Defaults to `<Outlet />` for data-router chrome wrappers. */
  children?: SideNavLayoutProps["children"];
};

/**
 * Thin data-router wrapper around Beam's `SideNavLayout`.
 *
 * Role: shared chrome primitive for migrated domains that need a side nav rail.
 * Does **not** replace the legacy `src/components/layout/SideNavLayout` — leave that
 * alone for Project / Development / Libraries pages still on the old stack.
 *
 * Domain chrome (e.g. `src/routes/admin/components/AdminSideNavLayout`) supplies
 * `sideNav` items and nests this under `BeamNavbarLayout`. See `src/routing/DESIGN.md`
 * "Chrome wrappers".
 */
export function BeamSideNavLayout(props: BeamSideNavLayoutProps) {
  const { children, ...sideNavLayoutProps } = props;
  return <SideNavLayout {...sideNavLayoutProps}>{children ?? <Outlet />}</SideNavLayout>;
}
